export const APEX_LOGO = "https://customer-assets.emergentagent.com/job_apex-freight-1/artifacts/a1jdd1ff_Screenshot%202026-04-14%20113623.png";
